import * as React from 'react'
import { useMemo } from 'react'
import BaseTimeOverview, { TimeFilterType } from '../Time/BaseTimeOverview'
import { BaseTimeOverviewProps } from './BaseTimeOverview'

export default function TimeOverview(props?: BaseTimeOverviewProps) {
    const fixedFilterValues = useMemo<Partial<TimeFilterType>>(
        () => ({
            files: props.fileId ? [props.fileId] : undefined,
        }),
        [],
    )

    return <BaseTimeOverview {...props} fixedFilterValues={fixedFilterValues} hideFileField={!!props.fileId} />
}
